<template>
    <div class="w-full pl-6 h-20 border-b">
        <div class="w-full h-full flex justify-start lg:justify-center items-center mx-auto relative">
            <h4 class="text-yank">{{ title }}<span class="text-payneHot">({{ count }})</span></h4>
            <div class="absolute right-0 inset-y-0 flex items-center mr-5 text-xs">
                <CreateFolder @submit="(folderName) => $emit('createFolder', folderName)" />
                <button @click="$emit('displayDownloadSection')" class="btn p-3 flex items-center justify-center border-2 border-yank border-opacity-10 hover:border-opacity-20 text-yank hover:text-opacity-70 transition shadow-sm">
                    <PlusIcon class="md:h-3 md:w-3 w-4 h-4 opacity-20"/>
                    <span class="ml-2 hidden md:block">Upload File</span> 
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PlusIcon from '@/components/svg/PlusIcon'
import CreateFolder from '@/components/my-media/CreateFolder'

export default {
    name:"Header",

    components: {
        CreateFolder,
        PlusIcon
    },

    props: {
        title: {
            type: String,
            default: 'My Media '
        },

        count: {
            type: Number,
            required: true
        },
    },
}
</script>